import ConfirmationDialog from '@rio-cloud/rio-uikit/ConfirmationDialog';
import Notification from '@rio-cloud/rio-uikit/Notification';
import Spinner from '@rio-cloud/rio-uikit/Spinner';
import { FormattedMessage, useIntl } from 'react-intl';

import { useCancelSelectedOpenOrders } from '../hooks/useCancelSelectedOpenOrders.ts';

type CancelSelectedOpenOrdersConfirmationDialogProps = {
    onClose: () => void;
    selectedOrderIds: string[];
    show: boolean;
};

export const CancelSelectedOpenOrdersConfirmationDialog = ({
    onClose,
    selectedOrderIds,
    show,
}: CancelSelectedOpenOrdersConfirmationDialogProps) => {
    const intl = useIntl();
    const { cancelSelectedOpenOrders, isLoading } = useCancelSelectedOpenOrders();

    const handleCancel = () => {
        if (!isLoading) {
            onClose();
        }
    };

    const handleConfirm = async () => {
        const { failureCount } = await cancelSelectedOpenOrders(selectedOrderIds);
        if (failureCount > 0) {
            Notification.error(
                intl.formatMessage(
                    {
                        id: 'intl-msg:ordercom-cloud-frontend.orders.cancel.multiple.failure',
                    },
                    { count: failureCount }
                )
            );
        }
        onClose();
    };

    return (
        <ConfirmationDialog
            show={show}
            title={<FormattedMessage id='intl-msg:ordercom-cloud-frontend.orders.cancel.multiple.confirm.title' />}
            content={
                <FormattedMessage
                    id='intl-msg:ordercom-cloud-frontend.orders.cancel.multiple.confirm.content'
                    values={{ count: selectedOrderIds.length }}
                />
            }
            cancelButtonText={
                <FormattedMessage id='intl-msg:ordercom-cloud-frontend.orders.cancel.multiple.confirm.cancel' />
            }
            confirmButtonText={
                <span className='display-flex align-items-center gap-5'>
                    {isLoading && <Spinner isInline isInverse />}
                    <span>
                        <FormattedMessage id='intl-msg:ordercom-cloud-frontend.orders.cancel.multiple.confirm.confirm' />
                    </span>
                </span>
            }
            disableConfirm={isLoading}
            disableEsc={isLoading}
            onClickCancel={handleCancel}
            onClickConfirm={handleConfirm}
        />
    );
};
